// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".time-input[data-v-2d1fb7c8] {\n  display: flex;\n  justify-content: center;\n  padding: 10px 0;\n  border-bottom: 1px solid #d2d8e5;\n  background: #fff;\n}", ""]);
// Exports
module.exports = exports;
